"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const numeric_1 = require("../numeric");
const trace = false;
let all;
let all_index;
const fields = ['code', 'numeric'];
function build() {
    if (all == null) {
        trace && console.time('ISO15924 db');
        all_index = {};
        all = require('iso-15924');
        for (let i = 0, l = all.length; i < l; ++i) {
            const isoData = all[i];
            for (let i = 0; i < fields.length; ++i) {
                const field = isoData[fields[i]];
                if (field) {
                    const value = field.toLowerCase();
                    if (trace) {
                        const previous_entry = all_index[value];
                        if (previous_entry && (isoData !== previous_entry)) {
                            trace && console.error(`ISO15924 ${isoData} conflicts with ${previous_entry}`);
                        }
                    }
                    all_index[value] = isoData;
                }
            }
        }
        trace && console.timeEnd('ISO15924 db');
    }
}
function getList() {
    build();
    return all;
}
exports.getList = getList;
function find(data) {
    build();
    let dataC;
    if (numeric_1.isNumeric(data)) {
        dataC = numeric_1.padLeft('000', data);
    }
    else {
        dataC = data.toLowerCase();
    }
    const isoData = all_index[dataC];
    return isoData;
}
exports.find = find;
//# sourceMappingURL=iso-15924-impl.js.map